import MuiBox from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { ReactComponent as CloseIcon } from "../../assets/images/close-icon.svg";
import { useNavigationSiteCore } from "../../hooks/useNavigationSiteCore";
import { useSiteCore } from "../../hooks/useSiteCore";
import { MuiButtonPrimary, MuiButtonSecondary } from "../button/MuiButton";
import { BaseStyledChipPopover } from "../chipWithPopoverBase/MuiChipWithPopoverBase.style";
import { FormController } from "../formController/FormController";
import { TextFieldCurrency } from "../textFieldCurrency/TextFieldCurrency";
import { InlineEditWrapper } from "./InlineEditPopup.style";

interface InlineEditPopupProps {
  anchorEl?: HTMLButtonElement | null;
  label: string;
  onClose: () => void;
  onSave: (value: string) => void;
  formId: string;
  currencyLocale: string;
  pageId: string;
  zeroValidationMessage: string;
  formatErrorMessage: string;
  ignoreZeroValidation?: boolean;
}

export const InlineEditPopup: React.FC<InlineEditPopupProps> = ({
  anchorEl = null,
  label,
  onClose,
  onSave,
  formId,
  currencyLocale,
  pageId,
  zeroValidationMessage,
  formatErrorMessage,
  ignoreZeroValidation,
}) => {
  const { commonLabels } = useSiteCore();
  const { commonARIALabel } = useNavigationSiteCore();

  const { control, getValues } = useFormContext();

  const handleSave = () => {
    onSave(getValues(formId));
  };

  const [gridWidth, setGridWidth] = useState(0);

  useEffect(() => {
    if (anchorEl) {
      setGridWidth(400);
    }
  }, [anchorEl]);

  return (
    <BaseStyledChipPopover
      open={Boolean(anchorEl)}
      anchorEl={anchorEl}
      className="base-chip-popover"
      popoverWidth={gridWidth}
      minWidth={400}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <InlineEditWrapper>
        <MuiBox className="inline-edit-modal-box">
          <MuiBox className="inline-edit-close-icon" onClick={onClose}>
            <CloseIcon />
          </MuiBox>
          <MuiBox>
            <FormController control={control} name={formId}>
              <TextFieldCurrency
                id={`${pageId}-${formId}`}
                formId={formId}
                locale={currencyLocale}
                isCurrencyChanged={`${getValues(formId)}${currencyLocale}`}
                label={label}
                placeholder={commonLabels.inputPlaceHolder}
                zeroValidationMessage={zeroValidationMessage}
                ignoreZeroValidation={ignoreZeroValidation}
                formatErrorMessage={formatErrorMessage}
                requiredARIALabel={commonARIALabel.required}
              />
            </FormController>
          </MuiBox>
          <MuiBox className="inline-edit-footer">
            <MuiButtonPrimary onClick={onClose}>
              {commonLabels.close}
            </MuiButtonPrimary>
            <MuiButtonSecondary onClick={handleSave}>
              {commonLabels.save}
            </MuiButtonSecondary>
          </MuiBox>
        </MuiBox>
      </InlineEditWrapper>
    </BaseStyledChipPopover>
  );
};
